<template>
  <pending-join-request-data-table :allupcomingparticipants="allupcomingparticipants"></pending-join-request-data-table>
</template>

<script>
import PendingJoinRequestDataTable from './PendingJoinRequestDataTable.vue';

export default {
  props: {
    allupcomingparticipants: {
      type: Array,
      required: true
    }
  },
  components: { PendingJoinRequestDataTable },
}
</script>